import { render, staticRenderFns } from "./EmailInfo.vue?vue&type=template&id=408fb730&scoped=true&"
import script from "./EmailInfo.vue?vue&type=script&lang=js&"
export * from "./EmailInfo.vue?vue&type=script&lang=js&"
import style0 from "./EmailInfo.vue?vue&type=style&index=0&id=408fb730&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408fb730",
  null
  
)

export default component.exports